import {connect} from 'react-redux';
import * as ModalActions from '../../actions/ModalActions';
import {withRouter} from 'react-router';
import AssistantInformationView from '../../../common/components/modal/AssistantInformationView';
import {State} from '../../../admin/types/mx/reducers';

const mapStateToProps = (state: State, ownProps) => {
    return {
        assistantInformation: ownProps.data.assistantInformation
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const AssistantInformationContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(AssistantInformationView));

export default AssistantInformationContainer;